<template>
  <div class="constel_details_page">
    <header v-if="isWeaWvFullScreen">
      <div class="top_pad" :style="{ height: `${statusHeight}px` }"></div>
      <ul class="controls_container">
        <li class="header_left_col">
          <div class="header_back" @click="handleHeaderBackClick()"></div>
          <div>星座详情</div>
        </li>
      </ul>
    </header>

    <div class="constel_details_content">
      <div class="details_content_inner">
        <template v-if="selectedConstel.id">
          <div class="basics_info_section">
            <div class="basics_header">
              <div class="basics_name">
                <div class="cn_name">{{ selectedConstel.name }}</div>
                <div class="latin_name">拉丁名：{{ selectedConstel.latinName }}</div>
              </div>
              <div class="constel_icon">
                <img :src="selectedConstel.icon" alt="">
              </div>
            </div>
      
            <div class="basics_title">
              <div class="title_tag"></div>
              <div class="title_text">基本信息</div>
            </div>
            <ul class="basics_info_list">
              <template v-for="item in basicsInfo">
                <li class="info_item" v-if="selectedConstel[item.key]">
                  <div v-if="item.key === 'bestObs'" class="label">{{ item.name }}</div>
                  <div v-else class="label">
                    <div v-for="textItem in item.name" :key="textItem">{{ textItem }}</div>
                  </div>
                  
                  <div class="content">{{ selectedConstel[item.key] }}</div>
                </li>
              </template>
            </ul>
          </div>
      
          <div class="intro_section" v-if="selectedConstel.id">
            <div class="basics_title">
              <div class="title_tag"></div>
              <div class="title_text">星座介绍</div>
            </div>
            <div class="intro_content">{{ constelIntro }}</div>
          </div>
  
          <div class="constel_fortune_section" v-if="constelFortune.star">
            <div class="fortune_section_title">
              <div class="basics_title">
                <div class="title_tag"></div>
                <div class="title_text">星座运势</div>
              </div>
              <div class="view_more_btn" @click="handleFortuneMoreClick">
                <div class="text">查看更多</div>
                <div class="icon"></div>
              </div>
            </div>
            <div class="fortune_top">
              <div class="fortune_top_left">
                <div :class="`fortune_icon constel_${this.selectedId}`">
                </div>
                <div class="fortune_name">{{ constelFortune.star }}</div>
                <div class="fortune_date" v-if="twelveIdMap[this.selectedConstel.id]">{{ twelveIdMap[this.selectedConstel.id].dateRange }}</div>
              </div>
              <ul class="fortune_top_right">
                <li class="right_row">
                  <div class="label">幸运颜色</div>
                  <div class="content">{{ constelFortune.lucky_color }}</div>
                </li>
                <li class="right_row">
                  <div class="label">幸运数字</div>
                  <div class="content">{{ constelFortune.lucky_num }}</div>
                </li>
                <li class="right_row">
                  <div class="label">贵人星座</div>
                  <div class="content">{{ constelFortune.grxz }}</div>
                </li>
              </ul>
            </div>
            <div class="fortune_bottom">
              {{ constelFortune.general_txt }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import constelsData from '../constant/constelsData.js'; // 星座数据
import utils from '../utils/index.js';

export default {
  data() {
    return {
      selectedConstel: {},
      constelIntro: {},
      basicsInfo: [
        { key: 'raRange', name: '赤经' },
        { key: 'decRange', name: '赤纬' },
        { key: 'symbol', name: '象征物' },
        { key: 'lucida', name: '最亮星' },
        { key: 'area', name: '面积' },
        { key: 'containedStars', name: '所含星数' },
        { key: 'bestObs', name: '最佳观赏月份' }
      ],
      // 白羊座、金牛座、双子座、巨蟹座、狮子座、处女座
      // 天秤座、天蝎座、射手座、摩羯座、水瓶座、双鱼座
      twelveIdMap: {
        1: { id: 101, dateRange: '3.21-4.19' },
        2: { id: 102, dateRange: '4.20-5.20' },
        3: { id: 103, dateRange: '5.21-6.21' },
        4: { id: 104, dateRange: '6.22-7.22' },
        5: { id: 105, dateRange: '7.23-8.22' },
        6: { id: 106, dateRange: '8.23-9.22' },
        7: { id: 107, dateRange: '9.23-10.23' },
        8: { id: 108, dateRange: '10.24-11.22' },
        9: { id: 109, dateRange: '11.23-12.21' },
        10: { id: 110, dateRange: '12.22-1.19' },
        11: { id: 111, dateRange: '1.20-2.18' },
        12: { id: 112, dateRange: '2.19-3.20' }
      },
      constelFortune: {},
      selectedId: null,
      isWeaWvFullScreen: false,
      statusHeight: 24
    };
  },
  props: {},
  components: {},
  computed: {},
  watch: {},
  created() {},
  beforeMount() {
    this.statusHeight = utils.jsbGetStatusHeight();
    this.isWeaWvFullScreen = utils.isWeaWvFullScreen();

    this.findSelectedConstel();
    console.log('selectedConstel :>> %O', this.selectedConstel);
  },
  mounted() {
  },
  methods: {
    findSelectedConstel() {
      const query = this.$route.query;
      let id = +query.id;
      const isEfficient = Number.isInteger(id) && (id >= 1 && id <= 88);
      if (!isEfficient) {
        id = 1;
      }
      this.selectedId = id;
      const selectedConstel = constelsData.constels.find(item => item.id == id);
      this.selectedConstel = selectedConstel;
      this.constelIntro = constelsData.constelIntroMap[id].intro;

      this.getTwelveConstel(id);
    },
    getTwelveConstel(id) {
      const twelveConstel = this.twelveIdMap[id];
      if (twelveConstel) {
        const apiUrl = '//h5api.zuimeitianqi.com/h5DataServer/getXingzuodesc';
        const params = {
          apikey: '05a20e82b0137c9ebc224661a4dcbe6a',
          code: twelveConstel.id
        };
        return axios.get(apiUrl, { params: params }).then(res => {
          const status = res.status;
          const resData = res.data;
          if (status === 200) {
            const { resultcode, data } = resData;
            if (resultcode == '0') {
              this.constelFortune = data.find(item => item.xingZuoTime === 'day');
            } else {
              throw resData;
            }
          } else {
            throw resData;
          }
        }).catch(error => {
          this.constelFortune = {};
        });
      }
    },
    handleHeaderBackClick() {
      this.$router.go(-1);
    },
    handleFortuneMoreClick() {
      let cityId = this.$route.cityId;
      if (!cityId) {
        cityId = '01012507';
      }
      let url = `https://h5.zuimeitianqi.com/page/zh/star.html?cityId=${cityId}&source=zm&partner=hw`;
      const query = this.$route.query;
      const constelId = +query.id;
      const fortune = this.twelveIdMap[constelId];
      if (fortune) {
        const fortuneId = fortune.id;
        url = `${url}&code=${fortuneId}`
      }
      window.location.href = url;
    }
  },
};

</script>
<style scoped lang='scss'>
.constel_details_page {
  width: 100vw;
  height: 100vh;
  background: url('../assets/images/constels/background/constel_details_bg@2x.png') no-repeat #151A59;
  background-size: 100% auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .top_pad {
    height: 24px;
  }
  .controls_container {
    height: 48px;
    padding: 0 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .header_left_col {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      font-size: 20px;
      font-family: HarmonyOS_Sans_SC_Medium;
      color: rgba(255,255,255,0.9);
      line-height: 1;
      .header_back {
        width: 24px;
        height: 24px;
        margin-right: 8px;
        background: url('../assets/images/icon/ic_title_return@2x.png') no-repeat;
        background-size: contain;
      }
    }
  }

  .constel_details_content {
    width: 100%;
    flex-grow: 1;
    overflow-y: auto;
    padding: 14px 16px 16px;
    box-sizing: border-box;
  }
  
  .basics_info_section, .intro_section,
  .constel_fortune_section {
    padding: 12px;
    background: rgba(255, 255, 255, .1);
    border-radius: 12px;
  }

  .basics_info_section {
    .basics_title {
      height: 40px;
    }
  }

  .basics_header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
    .cn_name {
      font-size: 24px;
      font-family: HarmonyOS_Sans_SC_Medium;
      color: rgba(0,218,255,0.9);
      line-height: 1;
    }
    .latin_name {
      margin: 12px 0 0 0;
      font-size: 18px;
      font-family: HarmonyOS_Sans_SC;
      color: rgba(0,218,255,0.6);
      line-height: 1;
    }
    .constel_icon {
      width: 72px;
      height: 72px;
      border-radius: 12px;
      overflow: hidden;
      background: rgba(255,255,255,0.1);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 56px;
        height: 56px;
      }
    }
  }

  .basics_title {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .title_tag {
      width: 4px;
      height: 14px;
      background: linear-gradient(180deg, rgba(0,218,255,0.8) 0%, rgba(0,218,255,0.3) 100%);
      border-radius: 2px;
      opacity: 0.7;
    }
    .title_text {
      margin: 0 0 0 4px;
      font-size: 16px;
      font-family: HarmonyOS_Sans_SC_Medium;
      color: rgba(0,218,255,0.9);
      line-height: 1;
    }
  }

  .info_item {
    height: 40px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .label {
      min-width: 60px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 14px;
      font-family: HarmonyOS_Sans_SC;
      color: rgba(255,255,255,0.6);
      line-height: 1;
    }
    .content {
      font-size: 14px;
      font-family: HarmonyOS_Sans_SC_Medium;
      color: rgba(255,255,255,0.9);
      line-height: 1;
    }
  }
  .info_item::after {
    content: " ";
    width: 200%;
    height: 200%;
    position: absolute;
    top: 0;
    left: 0;
    border-top: 1px solid rgba(255,255,255,0.1);
    transform: scale(0.5);
    transform-origin: 0 0;
    box-sizing: border-box;
  }

  .intro_section {
    margin-top: 16px;
    .basics_title {
      padding: 4px 0;
    }
    .intro_content {
      margin: 8px 0 0 0;
      font-size: 14px;
      font-family: HarmonyOS_Sans_SC;
      color: rgba(255,255,255,0.6);
      line-height: 24px;
    }
  }

  .constel_fortune_section {
    margin: 16px 0 0 0;
    .fortune_section_title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .view_more_btn {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        .text {
          font-size: 12px;
          font-family: HYQiHei-EES, HYQiHei;
          font-weight: normal;
          color: rgba(255,255,255,0.5);
          line-height: 1;
        }
        .icon {
          width: 12px;
          height: 12px;
          margin-left: 4px;
          background: url('../assets/images/icon/ic_arrow_more_white@2x.png') no-repeat;
          background-size: contain;
        }
      }
    }
    .fortune_top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 16px 0 0 28px;
      .fortune_top_right {
        .right_row {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          margin: 16px 0 0 0;
          font-size: 14px;
          font-family: HarmonyOS_Sans_SC;

          .label {
            width: 70px;
            color: rgba(255,255,255,0.6);
            // line-height: 1;
          }
          .content {
            width: 60px;
            color: rgba(255,255,255,0.9);
          }
        }
      }

      .fortune_top_left {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .fortune_icon {
          width: 48px;
          height: 48px;
        }
        .constel_1 {
          background: url('../assets/images/constels/twelveConstels/Aries@2x.png') no-repeat;
          background-size: contain;
        }
        .constel_2 {
          background: url('../assets/images/constels/twelveConstels/Taurus@2x.png') no-repeat;
          background-size: contain;
        }
        .constel_3 {
          background: url('../assets/images/constels/twelveConstels/Gemini@2x.png') no-repeat;
          background-size: contain;
        }
        .constel_4 {
          background: url('../assets/images/constels/twelveConstels/Cancer@2x.png') no-repeat;
          background-size: contain;
        }
        .constel_5 {
          background: url('../assets/images/constels/twelveConstels/Leo@2x.png') no-repeat;
          background-size: contain;
        }
        .constel_6 {
          background: url('../assets/images/constels/twelveConstels/Virgo@2x.png') no-repeat;
          background-size: contain;
        }
        .constel_7 {
          background: url('../assets/images/constels/twelveConstels/Libra@2x.png') no-repeat;
          background-size: contain;
        }
        .constel_8 {
          background: url('../assets/images/constels/twelveConstels/Scorpius@2x.png') no-repeat;
          background-size: contain;
        }
        .constel_9 {
          background: url('../assets/images/constels/twelveConstels/Sagittarius@2x.png') no-repeat;
          background-size: contain;
        }
        .constel_10 {
          background: url('../assets/images/constels/twelveConstels/Capricornus@2x.png') no-repeat;
          background-size: contain;
        }
        .constel_11 {
          background: url('../assets/images/constels/twelveConstels/Aquarius@2x.png') no-repeat;
          background-size: contain;
        }
        .constel_12 {
          background: url('../assets/images/constels/twelveConstels/Pisces@2x.png') no-repeat;
          background-size: contain;
        }
        .fortune_name {
          margin: 8px 0 0 0;
          font-size: 16px;
          font-family: HarmonyOS_Sans_SC_Medium;
          color: rgba(255,255,255,0.9);
          line-height: 1;
        }
        .fortune_date {
          margin: 8px 0 0 0;
          font-size: 12px;
          font-family: HarmonyOS_Sans_SC;
          color: rgba(255,255,255,0.6);
          line-height: 1;
        }
      }
    }
    .fortune_bottom {
      margin: 16px 0 0 0;
      font-size: 14px;
      font-family: HarmonyOS_Sans_SC;
      color: rgba(255,255,255,0.6);
      line-height: 1.8;
    }
  }
}
</style>
